import { render, staticRenderFns } from "./MovementsTab.vue?vue&type=template&id=0c08c596&"
import script from "./MovementsTab.vue?vue&type=script&lang=js&"
export * from "./MovementsTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports